import { useContext } from 'react';
import { ThemeContext, type ThemeContextValue } from './theme-context';

/**
 * Read the theme + setters. Must be used under `<ThemeProvider>`.
 */
export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (ctx === null) {
    throw new Error('useTheme() must be used within <ThemeProvider>');
  }
  return ctx;
}
